import { enableAutoTrack, makeTracker } from './auto';
import { type Events } from './events';
import { mixpanel } from './mixpanel';
import { sentry } from './sentry';
import {
  track as aliTrack,
  initTracking,
  setUserId,
  getTracker,
} from './ali-init';
export const track = makeTracker((event, props) => {
  // mixpanel.track(event, props);
  console.log('aaaaaaaaa，埋点上报3333', event, props);
  aliTrack(event, props);
});

export {
  aliTrack,
  enableAutoTrack,
  type Events,
  initTracking,
  mixpanel,
  sentry,
  setUserId,
  getTracker,
};
export default track;
